import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init
const firebaseConfigDev = {
  apiKey: "AIzaSyCHo9CqIf4Zip6W36zIiYEATDtht84KUJU",
  authDomain: "findupix.firebaseapp.com",
  projectId: "findupix",
  storageBucket: "findupix.appspot.com",
  messagingSenderId: "113267854571",
  appId: "1:113267854571:web:e99096e9a570bbef1ac2ae"
}

const firebaseConfigProd = {
  apiKey: "AIzaSyBDPqMjo1q6csKSevVxs_GdEcv4cDpwJ9o",
  authDomain: "findupix-5497c.firebaseapp.com",
  projectId: "findupix-5497c",
  storageBucket: "findupix-5497c.appspot.com",
  messagingSenderId: "1056120538255",
  appId: "1:1056120538255:web:f32983718e9c18e19e9cfa"
};

const firebaseConfig = process.env.VUE_APP_FIREBASE_CONFIG === 'prod' ? firebaseConfigProd : firebaseConfigDev

firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()

// collection references
const usersCollection = db.collection('users')
const galleriesCollection = db.collection('galleries')
const imagesCollection = db.collection('images')
const participantsCollection = db.collection('participants')

// export utils/refs
export {
  db,
  auth,
  usersCollection,
  galleriesCollection,
  imagesCollection,
  participantsCollection
}
